<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="params" label-width="77px" class="ele-form-search" @keyup.enter.native="searchChart" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="5" :sm="12">
            <el-form-item label="日期:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="handleDateChange"
                clearable
                style="width: 270px"
              />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="年级:">
              <el-select v-model="params.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="4" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchChart" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button type="primary" @click="exportData" icon="el-icon-download" class="ele-btn-icon">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="analysis-chart-card-content">
        <ele-chart ref="charts" :option="option1" style="height: 500px" />
      </div>
    </el-card>
  </div>
</template>

<script>
  import EleChart from '@/components/EleChart';
import { gradeAccessStatisticsChart, gradeAccessStatisticsChartExport, getGradeList } from '@/config/yizhongDong/examine';

  export default {
    name: 'GradeChart',
    components: { EleChart },
    data() {
      return {
        params: {
          startTime: '',
          endTime: '',
          branchId: undefined,
          gradeId: undefined,
        },
        date: null,
        gradeList: [],
        chartData: [],
      };
    },
    computed: {
      option1() {
        const chartData = this.chartData || [];
        // X轴：班级名称
        const classNames = chartData.map((item) => item.className);
        // 收集所有测评项名称（去重），作为多个 series
        const itemNames = [];
        chartData.forEach((cls) => {
          (cls.data || []).forEach((d) => {
            if (itemNames.indexOf(d.name) === -1) itemNames.push(d.name);
          });
        });
        // 为每个测评项构建数据数组（按班级顺序对齐）
        const series = itemNames.map((name) => ({
          name: name,
          type: 'bar',
          barMaxWidth: 36,
          label: {
            show: true,
            position: 'top',
            formatter: '{c}',
          },
          data: chartData.map((cls) => {
            const found = (cls.data || []).find((d) => d.name === name);
            return found ? Number(found.value) : 0;
          }),
        }));
        return {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
          },
          legend: {
            data: itemNames,
            top: 0,
          },
          grid: {
            left: 40,
            right: 30,
            top: itemNames.length > 0 ? 35 : 15,
            bottom: classNames.length > 8 ? 90 : 45,
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: classNames,
            axisLabel: {
              interval: 0,
              rotate: classNames.length > 8 ? 35 : 0,
            },
          },
          yAxis: {
            type: 'value',
            name: '分值',
          },
          dataZoom:
            classNames.length > 12
              ? [
                  {
                    type: 'slider',
                    start: 0,
                    end: 60,
                    bottom: 18,
                  },
                ]
              : [],
          series: series,
        };
      },
    },
    created() {
      this.loadGradeList();
    },
    methods: {
      // 加载年级列表
      async loadGradeList() {
        try {
          const res = await getGradeList();
          if (res.data.resCode == 200) {
            this.gradeList = res.data.data || [];
            if (this.gradeList.length > 0) {
              const firstGrade = this.gradeList[0];
              this.params.gradeId = firstGrade.id;
              this.params.branchId = firstGrade.branchId;
              this.searchChart();
            }
          }
        } catch (error) {
          console.error('加载年级列表失败:', error);
        }
      },
      // 选择年级时
      handleGradeChange (gradeId) {
        const grade = this.gradeList.find((item) => item.id == gradeId);
        this.params.branchId = grade ? grade.branchId : undefined;
      },
      // 选择时间
      handleDateChange(value) {
        if (value) {
          this.params.startTime = value[0];
          this.params.endTime = value[1];
        } else {
          this.params.startTime = '';
          this.params.endTime = '';
        }
      },
      // 查询数据
      searchChart() {
        if (!this.params.gradeId) return this.$message.error('请选择年级');
        gradeAccessStatisticsChart(this.params).then((res) => {
          if (res.data.resCode == 200) {
            this.chartData = res.data.data || [];
            this.$nextTick(() => {
              this.$refs.charts.init();
              this.$refs.charts.resize();
            });
          }
        });
      },
      // 导出数据
      exportData() {
        gradeAccessStatisticsChartExport(this.params).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
